import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { selectQueryParams } from 'stash/selectors';
import { selectIsAuthenticated } from 'stash/selectors/session';
import AuthRedirect from './AuthRedirect';

const mapStateToProps = (state, ownProps) => {
	const query = selectQueryParams(ownProps);
	return {
		isAuthenticated: selectIsAuthenticated(state),
		query,
	};
};

export const LogIn = ({ isAuthenticated, query }) => {
	// use React.useState to allow Jest to mock the function in tests
	const [isLoaded, setIsLoaded] = React.useState(false);

	useEffect(() => {
		setIsLoaded(true);
	}, []);
	const getRedirectUrl = () => {
		// Redirect to the ?r param after log in. Be careful of user input here.
		return query.r || '/';
	};

	if (isAuthenticated) {
		return <Redirect to={getRedirectUrl()} />;
	} else if (isLoaded) {
		return <AuthRedirect redirect={getRedirectUrl()} />;
	} else {
		return <div />;
	}
};
LogIn.propTypes = {
	isAuthenticated: PropTypes.bool,
	query: PropTypes.object,
	history: PropTypes.shape({
		replace: PropTypes.func,
	}),
};

export default connect(mapStateToProps)(LogIn);
